import React from "react";
import { FaCartShopping, FaGear, FaChartSimple, FaHeadset } from "react-icons/fa6";
import { Container, H2_SIZE, H3_SIZE } from "../home/ui";

const reasons = [
  { icon: FaCartShopping, title: "Conversion-Focused Design", text: "Engaging layouts that turn visitors into customers.", tone: "from-[#E6EDFF] to-[#EEF2FF] text-[#3D5BF6]" },
  { icon: FaGear, title: "Customized Solutions", text: "Tailored to your business goals and industry needs.", tone: "from-[#F1E6FF] to-[#F6EEFF] text-[#8B2CF5]" },
  { icon: FaChartSimple, title: "Scalable & Secure", text: "Built with best practices for performance, security, and scalability.", tone: "from-[#E3F4FF] to-[#EDF8FF] text-[#0EA5E9]" },
  { icon: FaHeadset, title: "Ongoing Support", text: "Continuous maintenance and feature updates for long-term growth.", tone: "from-[#E6EDFF] to-[#F0EEFF] text-[#3D5BF6]" },
];

const WhyChooseEcom = () => (
  <section className="relative overflow-hidden bg-white py-[48px] lg:py-[64px]">
    <div className="pointer-events-none absolute -right-[80px] -top-[40px] hidden h-[220px] w-[220px] rounded-full bg-[#F4EEFF] lg:block" />
    <Container className="relative max-w-[1320px]">
      <h2 className={`font-bold tracking-tight text-[#0B0D2C] ${H2_SIZE}`}>
        Why Choose Datametricks for
        {" "}<br />
        <span className="text-[#7C2CF0]"><span className="whitespace-nowrap">E-commerce</span> Development?</span>
      </h2>
      <p className="mt-[12px] max-w-[560px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
        We combine design, technology, and business strategy to create online stores that not only look great but also
        drive real sales and customer loyalty.
      </p>

      <div className="m-swipe mt-[28px] grid gap-[20px] sm:grid-cols-2 lg:grid-cols-4">
        {reasons.map((r) => (
          <div
            key={r.title}
            className="rounded-[18px] border-[1px] border-solid border-[#F0F2F8] bg-white p-[24px] shadow-[0_14px_34px_-22px_rgba(40,60,140,0.35)] transition hover:-translate-y-1"
          >
            <span className={`inline-flex h-[64px] w-[64px] items-center justify-center rounded-full bg-gradient-to-br text-[28px] ${r.tone}`}>
              <r.icon />
            </span>
            <h3 className={`mt-[16px] font-semibold text-[#0B0D2C] ${H3_SIZE}`}>{r.title}</h3>
            <p className="mt-[8px] text-[14.5px] leading-[1.55] text-slate-600">{r.text}</p>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default WhyChooseEcom;
